import { handleUpdateCall, useCartMutation } from './helpers/mutation-helper';
import { getExchangeCartId, getIsBrandPricingPolicyCompliant } from '../util/utils';

export const useAddToCart = () => {
  const [addToCartMutation, atcResponse] = useCartMutation('addToCart');

  // mutation wrapper
  const addToCart = ({
    cartRequest, onComplete, component, requestContext: requestContextOverride, userId, customerId
  }) => {
    const variables = {
      cartRequest,
      requestContext: requestContextOverride || {
        ...(getExchangeCartId() && { cartId: getExchangeCartId() }),
        isBrandPricingPolicyCompliant: getIsBrandPricingPolicyCompliant()
      },
      ...(userId !== undefined && { userId }),
      ...(customerId !== undefined && { customerId }),
    };
    // returns promise
    return handleUpdateCall({
      mutationName: 'addToCart',
      mutator: addToCartMutation,
      variables,
      onComplete,
      component,
    });
  };

  return [addToCart, atcResponse];
};
